import { useEffect } from 'react';

import { useLocation, useNavigationType } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname } = useLocation();
  const navigationType = useNavigationType();
  useEffect(() => {
    // 뒤로/앞으로 가기(POP)는 각 페이지가 스크롤 위치를 복원할 수 있도록 맨 위로 강제 이동하지 않는다.
    if (navigationType === 'POP') return;
    window.scrollTo(0, 0);
  }, [pathname, navigationType]);
  return null;
};
